export const normalizeSearchAgentsResponse = (response) => {
  const agents = response && Array.isArray(response.agents) ? response.agents : [];

  return { agents };
};

const searchAgentAdapter = (agent) => {
  if (!agent) return null;

  return {
    first_name: agent.firstName,
    last_name: agent.lastName || "",
    uam_id: agent.uamId,
    admission_number: agent.admissionNumber,
    phone: agent.phone,
    crn_id: agent.crnId || "",
    isd_code:
      agent.isdCode == null ? "" : String(agent.isdCode).trim(),
    email: agent.email || null,
    is_active: agent.isActive,
  };
};

export default searchAgentAdapter;
